<script setup>
    import { SquaresPlusIcon } from '@heroicons/vue/24/outline'
</script>

<template>
    <SquaresPlusIcon />
</template>
